import React from "react";
import { Identifiable, Project } from "@planzone/dto";
import { WeatherReport } from "@common/weatherReport";
import { Props } from "./types";
import styles from "./styles.scss";

function getZoneAverageScore(projects: Identifiable<Project>[]): number {
  return projects.length !== 0
    ? Math.floor(
        projects.reduce(
          (sum, project) => sum + parseInt(project.attributes.weather),
          0,
        ) / projects.length,
      )
    : 0;
}

function AverageWeather({ weather }: Props) {
  return (
    <div className={styles.weatherReport}>
      <div className={styles.iconBox}>
        <WeatherReport weather={`${weather}`} className={styles.icon} />
      </div>
      <p className={styles.averageScore}>{parseInt(weather) + 1}/5</p>
    </div>
  );
}

export { AverageWeather };
